import { PopupType } from '@nx-frontend/shared/types';
import { PageWidgetActionType, Template } from '@nx-frontend/shared/types';
import { OpenModalFn } from '@nx-frontend/shared/types';

export type TemplatePageActionFn = (
  openModal: OpenModalFn,
  handleCreatePage: (action: PageWidgetActionType, templates?: Template[]) => Promise<void>
) => void;

export const createTemplatePage: TemplatePageActionFn = (
  openModal: OpenModalFn,
  handleCreatePage: (action: PageWidgetActionType, templates?: Template[]) => Promise<void>
) => {
  openModal({
    title: ' ',
    content: PopupType.TEMPLATE_PAGE,
    showCloseButton: true,
    closeButtonSize: 18,
    payload: {
      payloadType: PopupType.TEMPLATE_PAGE,
      onApply: handleCreatePage,
    },
  });
};
